import { Reference } from "@apollo/client";

import useMutationWithValidation from "@hooks/useMutationWithValidation";
import {
  FolderDestroyDocument,
  FolderDestroyMutation,
  FolderDestroyMutationVariables,
  GetJourneyWithDocumentsQuery
} from "@typing/Generated";

const useDestroyFolder = (journey: GetJourneyWithDocumentsQuery["journey"]) => {
  const [mutation] = useMutationWithValidation<FolderDestroyMutation, FolderDestroyMutationVariables>(
    FolderDestroyDocument,
    "folder",
    {
      update: (store, { data }) => {
        if (data?.folderDestroy?.id) {
          store.modify({
            fields: {
              folders(cachedRefs: readonly Reference[], { readField }) {
                return cachedRefs.filter(ref => data.folderDestroy?.id !== readField("id", ref));
              }
            },
            id: store.identify({ ...journey })
          });

          journey.fileResources
            .filter(file => file.folder?.id === data.folderDestroy?.id)
            .map(file => {
              store.modify({
                fields: {
                  folder() {
                    return null;
                  }
                },
                id: store.identify({ ...file })
              });
            });
        }
      }
    }
  );
  return mutation;
};

export default useDestroyFolder;
